import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ExtCalendlyConfigModel } from '@smarttask-common/src/lib/models/Integrations/Calendly/ExtCalendlyConfigModel';

export enum ExtCalendlyConfigActionTypes {
    ADD_EXT_CALENDLY_CONFIG = '[ExtCalendlyConfig] Create ExtCalendlyConfig',
    ADD_EXT_CALENDLY_CONFIGS = '[ExtCalendlyConfig] Add ExtCalendlyConfigs',
    UPSERT_EXT_CALENDLY_CONFIG = '[ExtCalendlyConfig] Upsert ExtCalendlyConfig',
    UPSERT_EXT_CALENDLY_CONFIGS = '[ExtCalendlyConfig] Upsert ExtCalendlyConfigs',
    UPDATE_EXT_CALENDLY_CONFIG = '[ExtCalendlyConfig] Update ExtCalendlyConfig',
    UPDATE_EXT_CALENDLY_CONFIGS = '[ExtCalendlyConfig] Update ExtCalendlyConfigs',
    DELETE_EXT_CALENDLY_CONFIG = '[ExtCalendlyConfig] Delete ExtCalendlyConfig',
    DELETE_EXT_CALENDLY_CONFIGS = '[ExtCalendlyConfig] Delete ExtCalendlyConfigs',
    DELETE_ALL_EXT_CALENDLY_CONFIGS = '[ExtCalendlyConfig] Delete All ExtCalendlyConfigs',
    DELETE_ALL = '[ExtCalendlyConfig] Delete All',

    UPDATE_SELECTED_ID = '[ExtCalendlyConfig] Update SelectedId',
}

export class UpdateSelectedConfigId implements Action {
    readonly type = ExtCalendlyConfigActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_config_id: string) {}
}

export class AddOne implements Action {
    readonly type = ExtCalendlyConfigActionTypes.ADD_EXT_CALENDLY_CONFIG;
    constructor(public config: ExtCalendlyConfigModel) {}
}

export class AddMany implements Action {
    readonly type = ExtCalendlyConfigActionTypes.ADD_EXT_CALENDLY_CONFIGS;
    constructor(public configs: Array<ExtCalendlyConfigModel>) {}
}

export class UpsertOne implements Action {
    readonly type = ExtCalendlyConfigActionTypes.UPSERT_EXT_CALENDLY_CONFIG;

    constructor(public config: ExtCalendlyConfigModel) {}
}

export class UpsertMany implements Action {
    readonly type = ExtCalendlyConfigActionTypes.UPSERT_EXT_CALENDLY_CONFIGS;
    constructor(public configs: Array<ExtCalendlyConfigModel>) {}
}

export class UpdateOne implements Action {
    readonly type = ExtCalendlyConfigActionTypes.UPDATE_EXT_CALENDLY_CONFIG;
    constructor(public config: Update<ExtCalendlyConfigModel>) {}
}

export class UpdateMany implements Action {
    readonly type = ExtCalendlyConfigActionTypes.UPDATE_EXT_CALENDLY_CONFIGS;
    constructor(public configs: Array<Update<ExtCalendlyConfigModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = ExtCalendlyConfigActionTypes.DELETE_EXT_CALENDLY_CONFIG;
    constructor(public config_id: string) {}
}

export class DeleteMany implements Action {
    readonly type = ExtCalendlyConfigActionTypes.DELETE_EXT_CALENDLY_CONFIGS;
    constructor(public config_ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = ExtCalendlyConfigActionTypes.DELETE_ALL_EXT_CALENDLY_CONFIGS;
    constructor(public config_ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = ExtCalendlyConfigActionTypes.DELETE_ALL;
    constructor() {}
}

export type ExtCalendlyConfigActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedConfigId;
